import { useState } from 'react'
import { useAuth } from '@redwoodjs/auth'
import { Link } from '@redwoodjs/router'
import { Box, Flex, Text, Button, Link as ChakraLink, Stack, Heading } from '@chakra-ui/react'

export default function MainLayout() {
  const [isOpen, setIsOpen] = useState(false)
  const { isLoggedIn } = useAuth()

  const toggle = () => setIsOpen(!isOpen)

  return (
    <NavBarContainer>
      <ChakraLink as={Link} to="/">
        <Heading _hover={{ cursor: 'pointer' }}>PitLogger</Heading>
      </ChakraLink>
      <MenuToggle toggle={toggle} isOpen={isOpen} />
      <MenuLinks isOpen={isOpen} isLoggedIn={isLoggedIn} />
    </NavBarContainer>
  )
}

const CloseIcon = () => (
  <svg width="24" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <title>Close</title>
    <path
      fill="white"
      d="M9.00023 7.58599L13.9502 2.63599L15.3642 4.04999L10.4142 8.99999L15.3642 13.95L13.9502 15.364L9.00023 10.414L4.05023 15.364L2.63623 13.95L7.58623 8.99999L2.63623 4.04999L4.05023 2.63599L9.00023 7.58599Z"
    />
  </svg>
)

const MenuIcon = () => (
  <svg width="24px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="white">
    <title>Menu</title>
    <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
  </svg>
)

const MenuToggle = ({ toggle, isOpen }) => {
  return (
    <Box display={{ base: 'block', md: 'none' }} onClick={toggle}>
      {isOpen ? <CloseIcon /> : <MenuIcon />}
    </Box>
  )
}

const MenuItem = ({ children, to = '/' }) => {
  return (
    <Link to={to}>
      <Text display="block" _hover={{ cursor: 'pointer' }}>
        {children}
      </Text>
    </Link>
  )
}

const MenuLinks = ({ isOpen }) => {
  const { logIn, logOut, signUp, isAuthenticated } = useAuth()

  return (
    <Box display={{ base: isOpen ? 'block' : 'none', md: 'block' }} flexBasis={{ base: '100%', md: 'auto' }}>
      <Stack
        spacing={8}
        align="center"
        justify={['center', 'space-between', 'flex-end', 'flex-end']}
        direction={['column', 'row', 'row', 'row']}
        pt={[4, 4, 0, 0]}
      >
        {isAuthenticated && (
          <>
            <MenuItem to="/cooks">Cooks</MenuItem>
            {/* <MenuItem to='/sign-out'> */}
            <Button
              onClick={async () => {
                logOut({
                  returnTo: window.location.origin,
                })
              }}
              size="sm"
              rounded="md"
              color={['primary.500', 'primary.500', 'white', 'white']}
              bg={['white', 'white', 'primary.500', 'primary.500']}
              _hover={{
                bg: ['primary.100', 'primary.100', 'primary.600', 'primary.600'],
              }}
            >
              Sign Out
            </Button>
            {/* </MenuItem> */}
          </>
        )}
        {!isAuthenticated && (
          <>
            {/* <MenuItem to='/faetures'>Features</MenuItem>
            <MenuItem to='/pricing'>Pricing</MenuItem> */}
            <Button
              size="sm"
              rounded="md"
              onClick={() => signUp()}
              color={['primary.500', 'primary.500', 'white', 'white']}
              bg={['white', 'white', 'primary.500', 'primary.500']}
              _hover={{
                bg: ['primary.100', 'primary.100', 'primary.600', 'primary.600'],
              }}
            >
              Create Account
            </Button>

            <Button size="sm" rounded="md" variant="outline" onClick={() => logIn()}>
              Sign In
            </Button>
          </>
        )}
      </Stack>
    </Box>
  )
}

const NavBarContainer = ({ children, ...props }) => {
  return (
    <Flex
      as="nav"
      align="center"
      justify="space-between"
      wrap="wrap"
      w="100%"
      mb={8}
      p={3}
      bg={['primary.500', 'primary.500', 'transparent', 'transparent']}
      color={['white', 'white', 'primary.700', 'primary.700']}
      {...props}
    >
      {children}
    </Flex>
  )
}
